/* eslint-disable default-param-last */
import { actions, types } from './actions'

const initialState: ChallengeState = {
}

export const reducer = (state: ChallengeState = initialState, action: ActionsUnion<typeof actions>): ChallengeState => {
    switch (action.type) {
        case types.ASSIGN_CHALLENGE_SETTINGS:
            const payload = action.payload
            return {
                ...state,
                instanceSettings: payload as ChallengeSettingsDto,
            }
        case types.GET_CHALLENGE_DETAILS:
            return {
                ...state,
                challengeData: action.payload as ViewChallengeDataRecord,

            }
        case types.POPULATE_AMBASSADOR_PROFILE:
            return {
                ...state,
                ambassadorprofile: action.payload as AmbassadorProfileRecord,
            }
        default:
            return state
    }
}
